if (!customElements.get('deco-designer-directory')) {
  customElements.define(
    'deco-designer-directory',
    class DecoDesignerDirectory extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.cards = Array.from(this.querySelectorAll('[data-directory-card]'));
        this.searchInput = this.querySelector('[data-directory-search]');
        this.filterButtons = Array.from(this.querySelectorAll('[data-directory-filter]'));
        this.countOutput = this.querySelector('[data-directory-count]');
        this.emptyState = this.querySelector('[data-directory-empty]');
        this.activeBrand = 'all';

        this.searchInput?.addEventListener('input', () => this.update());
        this.filterButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.activeBrand = button.dataset.directoryFilter || 'all';
            this.filterButtons.forEach((item) => {
              item.setAttribute('aria-pressed', String(item === button));
            });
            this.update();
          });
        });

        this.update();
      }

      update() {
        const query = (this.searchInput?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const matchesBrand = this.activeBrand === 'all' || card.dataset.brand === this.activeBrand;
          const matchesQuery = !query || (card.dataset.search || '').includes(query);
          const visible = matchesBrand && matchesQuery;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (this.countOutput) this.countOutput.textContent = String(visibleCount);
        if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
      }
    }
  );
}
